import script from "./PokemonByType.vue?vue&type=script&setup=true&lang=js"
export * from "./PokemonByType.vue?vue&type=script&setup=true&lang=js"

import "./PokemonByType.vue?vue&type=style&index=0&id=386c6890&lang=scss"

const __exports__ = script;

export default __exports__